export const messages = {
  en: {
    reportRepair: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      beginStartTimePlaceholder: 'Please select creation start time',
      beginEndTimePlaceholder: 'Please select creation end time',
      finishStartTimePlaceholder: 'Please select completion start time',
      finishEndTimePlaceholder: 'Please select completion end time',
      communityPlaceholder: 'Please select community',
      search: 'Search',
      reset: 'Reset',
      staffPlaceholder: 'Please select staff name',
      statePlaceholder: 'Please select status',
      reportTitle: 'Repair Summary Report',
      tooltip: 'Display work order summary by staff dimension',
      export: 'Export',
      repairId: 'Repair ID',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      dealing: 'Processing (count)',
      dispatch: 'Dispatch (count)',
      transfer: 'Transfer (count)',
      chargeback: 'Chargeback (count)',
      returnVisit: 'Return Visit (count)',
      finished: 'Finished (count)',
      score: 'Staff Score',
      statistics: 'Statistics',
      timeError: 'End time must be greater than start time'
    }
  },
  zh: {
    reportRepair: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      beginStartTimePlaceholder: '请选择创建开始时间',
      beginEndTimePlaceholder: '请选择创建结束时间',
      finishStartTimePlaceholder: '请选择完结开始时间',
      finishEndTimePlaceholder: '请选择完结结束时间',
      communityPlaceholder: '请选择园区',
      search: '查询',
      reset: '重置',
      staffPlaceholder: '请选择员工姓名',
      statePlaceholder: '请选择状态',
      reportTitle: '报修汇总表',
      tooltip: '以员工为维度，展示员工处理工单情况汇总',
      export: '导出',
      repairId: '报修编号',
      staffId: '员工ID',
      staffName: '员工姓名',
      dealing: '处理中(条)',
      dispatch: '派单(条)',
      transfer: '转单(条)',
      chargeback: '退单(条)',
      returnVisit: '已回访(条)',
      finished: '已完结(条)',
      score: '员工评分',
      statistics: '统计',
      timeError: '结束时间必须大于开始时间'
    }
  }
}